export default "{\n    \"errors\": {\n        \"copyFailed\": \"Échec de la copie dans le presse-papiers\"\n    }\n}\n"